import { iframeDataBridge } from '../iframe/iframeDataBridge';
import { mountZone, unmountAll, mountDynamicPointsZone, mountDynamicKpiPosZone, mountDynamicPosMapZone } from '../mount/zoneMount';
import { log } from '../utils/vueLogger.js';
import { eventBus } from '../utils/eventBus';

let _externisReady = false;

function emitMainSyncCompleted() {
	log('success', 'iframeWatcher', '✅ Main sync completed — emitting main-sync-completed');
	eventBus.emit('main-sync-completed');

	const iframeDoc = iframeDataBridge.getIframeWindow().document;
	if (!iframeDoc.getElementById('vue-points-dialog-zone')) {
		const zoneEl = iframeDoc.createElement('div');
		zoneEl.id = 'vue-points-dialog-zone';
		iframeDoc.body.appendChild(zoneEl);
	}
	mountZone('vue-points-dialog-zone');
}

export function initIframeViewObserver(iframeSelector = 'iframe') {
	const iframe = iframeDataBridge.getIframe();

	// Listen to SYNC_COMPLETED postMessage from iframe — single reliable source
	window.addEventListener('message', (event) => {
		if (event.origin !== window.location.origin) return;
		if (event.data?.type === 'SYNC_COMPLETED' && event.data?.data?.app === 'ALL') {
			emitMainSyncCompleted();
		}
		if (event.data?.type === 'MOUNT_KPI_STATEMENT_ZONE') {
			mountZone('vue-kpi-statement-zone');
		}
		if (event.data?.type === 'MOUNT_POS_MAP_ZONE') {
			const zoneId = event.data?.zoneId;
			if (zoneId) mountDynamicPosMapZone(zoneId);
		}
		if (event.data?.type === 'MOUNT_KPI_POS_ZONE') {
			const zoneId = event.data?.zoneId;
			if (zoneId) mountDynamicKpiPosZone(zoneId);
		}
		if (event.data?.type === 'MOUNT_POINTS_STATEMENT_ZONE') {
			const zoneId = event.data?.zoneId;
			if (zoneId) {
				mountDynamicPointsZone(zoneId);
			} else {
				mountZone('vue-points-statement-zone');
			}
		}
	});

	iframe.onload = () => {
		const win = iframeDataBridge.getIframeWindow();

		// Periodically check if amplify and externis are ready in the iframe
		const checkReady = setInterval(() => {
			try {
				if (win?.amplify && win?.externis) {
					window.amplify = win.amplify;
					log('info', 'iframeWatcher', 'Added amplify to window');

					if (!_externisReady) {
						_externisReady = true;
						eventBus.emit('externis-ready');
					}
				}

				if (win?.amplify?.subscribe) {
					win.amplify.subscribe('evtChangeView', (evt) => {
						unmountAll();

						const view = evt?.view || evt?.currentView;
						log('info', 'iframeWatcher', `View changed to: ${view}`);

						switch (view || win.externis?.ecosVM?.currentView?.()) {
							case 'widgets':
							case 'vwWidgets':
								const vueWidgetOption = win.externis?.ecosVM.options.find((o) => o.name == 'VueWidgets');

								if (vueWidgetOption && vueWidgetOption.value === 'true') {
									mountZone('vue-widgets-zone');
								}
								break;

							case 'vwSFAPlanning':
								mountZone('vue-calendar-map-zone');
								break;

							case 'vwSFAPOS':
								break;

							case 'vw-visit':
								mountZone('vue-kpi-statement-zone');
								break;
						}
					});

					clearInterval(checkReady);
				}
			} catch (e) {
				// DOM not ready yet - continue checking
			}
		}, 300);
	};
}
